<template>
  <div id="app">
    <!-- ここからナビゲーションバー追加 -->
    <div>
      <b-navbar toggleable="lg" type="dark" variant="info">
        <b-navbar-brand target=”_blank” href="http://kit.socinno.com/">
          <img src="./assets/sLabLogo40.png" class="slablogo" >
          <h4>sLab-AI学習サイト</h4>（ディープラーニング） ver1.0
        </b-navbar-brand>

        <b-collapse id="nav-collapse" is-nav>

          <!-- Right aligned nav items -->
          <b-navbar-nav class="ml-auto">

            <b-nav-item target=”_blank” href="http://kit.socinno.com/1_1_ai/">AI基礎</b-nav-item>
            <b-nav-item target=”_blank” href="http://kit.socinno.com/3_1_ai/">NN学習</b-nav-item>
            <b-nav-item target=”_blank” href="http://kit.socinno.com/3_2_ai/">CNN学習</b-nav-item>
            <b-nav-item target=”_blank” href="http://kit.socinno.com/4_1_ai/">使い方</b-nav-item>

            <b-nav-item-dropdown right>
              <!-- Using 'button-content' slot -->
              <template v-slot:button-content>
                <em>メニュー</em>
              </template>
              <b-dropdown-item @click="saveFile">Save</b-dropdown-item>
              <b-dropdown-item @click="loadModalOn">Load</b-dropdown-item>
            </b-nav-item-dropdown>

          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </div>
    <!-- ここまでナビゲーションバー追加 -->
    <br/>
    <div  class="container">
      <router-view ref="rrouter"/>
    </div>

    <!-- Upload File modal -->
    <div class="modal-overlay" v-if="modalFileShow">
      <div class="modal-content">
        <br/><h6>ファイルUpload画面</h6><br/>
        <div
          :class="dragAreaCls"
          @dragover.prevent="checkDrag($event, true)"
          @dragleave.prevent="checkDrag($event, false)"
        >
          <input type="file" @change="loadfile">
          <div class="drop-area" @drop.prevent="loadfile"></div>
          <div class="drag-text"><b-icon icon="upload" variant="secondary" font-scale="5"></b-icon><br/>
            アップロードしたいファイルを<br/>ここにドラッグ＆ドロップ<br/><font size=-1>（Saveファイルが３つある場合は全てドロップして下さい）</font></div>
          </div>
        <br/><div class="cancelbtn">
        <b-button variant="outline-primary" size="sm" class="btnw" @click="cancelModal()">Cancel</b-button>
        </div><br/>
      </div>
    </div>

  </div>
</template>

<script>
import { mapState } from 'vuex'
import * as tf from '@tensorflow/tfjs'
import JSZip from 'jszip'
// const fs = require('fs')

export default {
  name: 'App',
  data () {
    return {
      modalFileShow: false,
      dragAreaCls: 'drag-area drag-area-normal',
      modelJson: null,
      modelWeight: null
    }
  },
  computed: {
    ...mapState([ 'manualInputFlag', 'samplebtn', 'kitDataType', 'cameraInput', 'cameraPredict', 'inputs', 'iimages', 'aimodels',
      'aimodelpara', 'setActions', 'setModals', 'setKits', 'resultGraph', 'model', 'controlKits', 'alwaysPredict' ])
  },
  methods: {
    checkDrag (event, status) {
      if (status && event.dataTransfer.types === 'text/plain') {
        // ファイルではなく、html要素をドラッグしてきた時は処理を中止
        return false
      }
      if (status) {
        this.dragAreaCls = 'drag-area drag-area-over'
      } else {
        this.dragAreaCls = 'drag-area drag-area-normal'
      }
    },
    async saveFile () {
      let csvf = '\ufeff\n'
      csvf += 'manualInputFlag' + '\t' + this.manualInputFlag + '\n'
      csvf += 'samplebtn' + '\t' + this.samplebtn + '\n'
      csvf += 'kitDataType' + '\t' + this.kitDataType + '\n'
      csvf += 'cameraInput' + '\t' + this.cameraInput + '\n'
      csvf += 'cameraPredict' + '\t' + this.cameraPredict + '\n'
      csvf += 'inputs' + '\t' + JSON.stringify(this.inputs, null, null) + '\n'
      csvf += 'iimages' + '\t' + JSON.stringify(this.iimages, null, null) + '\n'
      csvf += 'aimodels' + '\t' + JSON.stringify(this.aimodels, null, null) + '\n'
      csvf += 'aimodelpara' + '\t' + JSON.stringify(this.aimodelpara, null, null) + '\n'
      csvf += 'setActions' + '\t' + JSON.stringify(this.setActions, null, null) + '\n'
      csvf += 'setModals' + '\t' + JSON.stringify(this.setModals, null, null) + '\n'
      csvf += 'setKits' + '\t' + JSON.stringify(this.setKits, null, null) + '\n'
      csvf += 'resultGraph' + '\t' + JSON.stringify(this.resultGraph, null, null) + '\n'
      csvf += 'controlKits' + '\t' + JSON.stringify(this.controlKits, null, null) + '\n'
      // ------Zip処理開始------
      var zip = new JSZip()
      zip.file('aiKitParameters.txt', csvf)
      const tmpThis = this
      zip.generateAsync({type: 'blob'}).then(function (csvblob) {
        // see FileSaver.js
        tmpThis.downloadSave(csvblob)
      })
    },
    async downloadSave (blob) {
      // ------Zip処理終了------
      // NG: csvf += 'model' + '\t' + this.model + '\n'
      // var blob = new Blob([ csvf ], {'type': 'csv/plain'})
      let link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = 'aiKitParameters.zip'
      await link.click()
      // Save Model
      if (this.model !== undefined && this.model !== null && this.model !== '') {
        const modelfile = 'downloads://tensorflow'
        await this.model.save(modelfile)
      }
      // const blobModel = new Blob([this.model], {type: 'application/octet-binary'})
      // const modelfile = 'indexeddb://modelsave'
      // const modelfile = 'file://test-model'
      /* console.log(this.model)
      const tmpThis = this
      var reader = new FileReader()
      reader.onload = function () {
        csvf += 'model' + '\t' + reader.result + '\n'
        tmpThis.doSaveFile(csvf)
      }
      reader.readAsArrayBuffer(modelfile)
    },
    doSaveFile (csvf) {
      // csvf += 'alwaysPredict' + '\t' + this.alwaysPredict + '\n' //load時は常時予測はOFF(false)
      var blob = new Blob([ csvf ], {'type': 'csv/plain'})
      let link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = 'aiKitParameter.txt'
      link.click() */
      this.$store.dispatch('setMessage', '設定情報を保存しました。')
    },
    async loadfile (event) {
      this.$store.dispatch('setMessage', 'Loading....【Loadデータ量に応じて数秒から数分程度お待ちください】')
      // const fileList = event.target.files || event.dataTransfer.files
      const fileList = event.target.files || event.dataTransfer.files
      // ファイルが無い時は処理を中止
      if (fileList.length === 0) {
        this.$store.dispatch('setMessage', 'Load失敗、ファイル全体を枠内に移動しドロップして下さい')
        return false
      }
      this.modelJson = null
      this.modelWeight = null
      for (var i = 0; i < fileList.length; i++) {
        const chkFile = fileList[i].name
        // console.log('chkFile:' + chkFile)
        if (chkFile.match(/\.zip/)) {
          const tmpThis = this
          JSZip.loadAsync(fileList[i]).then(function (zip) {
            return zip.file('aiKitParameters.txt').async('string')
          }).then(function (text) {
            tmpThis.doLoadfile(text)
          })
          /* no Zip file
          const tmpThis = this
          const reader = new FileReader()
          reader.onload = function (e) {
            // console.log('onload:' + e.target.result)
            const filecontents = e.target.result
            tmpThis.doLoadfile(filecontents)
          }
          await reader.readAsText(fileList[i]) */
        // weights.binファイルはjsonと同時にUploadする必要があります。
        } else if (chkFile.match(/\.json/)) {
          this.modelJson = fileList[i]
        } else if (chkFile.match(/\.weights.bin/)) {
          this.modelWeight = fileList[i]
        }
      }
      this.cancelModal()
    },
    async doLoadfile (filecontents) {
      console.log('loadFile!')
      await this.$store.dispatch('loadFile', filecontents)
      /* // データを反映させないと異なる画面状態（MNIST画面でKitDataをLoadする等）で表示されエラーとなる
      setTimeout(this.doLoadImage, 250)
    },
    async doLoadImage () { */
      // ImageFileの表示
      console.log('loadImage!')
      await this.$refs.rrouter.loadRootImage()
      // Graphの表示
      await this.$refs.rrouter.loadRootGraph()
      // modelのLoad
      if (this.modelJson !== null && this.modelWeight !== null) {
        console.log('loadmodel!')
        const lmodel = await tf.loadLayersModel(tf.io.browserFiles([this.modelJson, this.modelWeight]))
        this.$store.dispatch('setAiResult', {loss: -1, acc: -1, model: lmodel})
      }
      // 完了表示
      this.$store.dispatch('setMessage', 'Loadが完了しました')
    },
    loadModalOn () {
      this.modalFileShow = true
    },
    cancelModal () {
      this.modalFileShow = false
    }
  }
}
</script>

<style scoped>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.slablogo {
  text-align: left;
  padding: 0 15px 0 25px;
  width: 80px;
  height: 40px;
}
img, h4 {
  display: inline;
  vertical-align: middle;
}
a:link { color: #fff; }
a:visited { color: #fff; }
a:hover { color: #fff; }
a:active { color: #fff; }
.drag-area {
  position: relative;
  width: 90%;
  height: 100%;
  min-height: 200px;
  margin: 0 5%;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.drop-area {
  z-index:200;
  position: absolute;
  top: -50px;
  left: -50px;
  width: calc(90% + 150px);
  height: calc(100% + 100px);
/*  width: 120%;
  height: 140%; */
  margin: 0;
  padding: 0;
}
.drag-area-normal {
  border: 3px dotted #ddd;
  background-color: #F5F5F5;
}
.drag-area-over {
  border: 3px dotted #eee;
  background-color: #d3d3d3;
}
.drag-text {
  position: absolute;
}
input {
  opacity: 0;
  width: 100%;
  height: 30vh;
}
.cancelbtn {
  text-align:  center;
  z-index:201;
}
</style>
<style>
 /************************************ Yama 追加 ************************************/
.relativecls {
  position: relative; /* 本来は元の一からの相対移動だが、これはabsoluteの親要素として固定 */
}
.inlinecls {
  display: inline;
}
.inlineblkcls {
  display: inline-block;
}
.color-gray {
  color: #999;
}
.btnw {
  width: 120px;
}
.widthmax {
  width: 100%;
}
.floatright {
  float: right;
}
.floatleft {
  float: left;
}
.modal-content{
  z-index:101;
  width:50% !important;
  padding: 5px;
  border: 0;
  background:#fff;
  max-height: 95vh;
  max-width: 95vw;
  overflow: auto;
}
.modal-overlay{
  /* 要素を重ねた時の順番 */
  z-index:100;
  /* 画面全体を覆う設定 */
  position:fixed;
  top:0;
  left:0;
  width:100%;
  height:100%;
  background-color:rgba(0,0,0,0.7);
  /* 画面の中央に要素を表示させる設定 */
  display: flex;
  align-items: center;
  justify-content: center;
}
.smallFont {
  font-size: 90%;
}
.tcenter {
  text-align:  center; /* INLINE,INLINE-Block要素の中央寄せ */
}
.mcenter {
  margin: 0 AUTO; /* Block要素の中央寄せ */
}
.nopad {
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue